import React, { Component } from "react";
import PropTypes from "prop-types";
import { TitleCase } from "../../common";
import { Form, Button } from "semantic-ui-react";

class RenameDraft extends Component {
  constructor(props) {
    super(props);
    var monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC"
    ];
    var date = new Date();
    date =
      date.getDate() +
      " " +
      TitleCase(monthNames[date.getMonth()]) +
      " " +
      date.getFullYear();

    this.state = {
      name: this.props.form_title + ", " + date,
      error: false,
      submitted: false
    };
  }

  RenameDraft(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    this.props.onRenameDraft(this.state.name);
  }

  updateInputValue(e) {
    var change = {};
    change[e.target.id] = e.target.value;
    this.setState(change);
  }

  renderError() {
    return <div></div>;
  }

  renderRenameDraft() {
    return (
      <div
        style={{
          width: "100%",
          paddingLeft: this.props.tablet ? "60px" : "40px",
          paddingRight: this.props.tablet ? "60px" : "40px"
        }}
        className="ui form login"
      >
        <form>
          <div className="formControlItem">
            <Form.Field>
              {this.renderError()}
              <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                Draft name
              </label>
              <div>
                <input
                  type="text"
                  style={{ width: "100%" }}
                  autoFocus
                  id="name"
                  placeholder=""
                  value={this.state.name}
                  onChange={e => this.updateInputValue(e)}
                />
              </div>
              <br></br>
              <Button
                style={{ width: "100%" }}
                className="ui active button"
                role="button"
                onClick={this.RenameDraft.bind(this)}
              >
                Save draft
              </Button>
            </Form.Field>
          </div>
        </form>
      </div>
    );
  }

  render() {
    return <div style={{ flex: 1 }}>{this.renderRenameDraft()}</div>;
  }
}

RenameDraft.propTypes = {
  form_title: PropTypes.string.isRequired,
  storeColour: PropTypes.object.isRequired,
  tablet: PropTypes.bool.isRequired
};

export default RenameDraft;



// WEBPACK FOOTER //
// ./src/components/RenameDraft/index.js